import { Component } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { MatMenuModule } from '@angular/material/menu';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  constructor(library: FaIconLibrary) {
    library.addIcons(faLinkedin);
    library.addIcons(faXTwitter);
  }

  navigateToConsumerX() {
    window.location.href = `${environment.raa.frontend_base}/applications/landing-page?redirect=cx`;
    
  }
}


